import myAxios from "@/utils/request";
export default {
  // 获取成果列表
  getAchProjectList(params) {
    return myAxios.post("/api/Project/GetAchvProOutList", params);
  },
  // 获取需求列表
  getDemProjectList(params) {
    return myAxios.post("/api/Project/GetReqProOutList", params);
  },
  // 删除
  deleteProject(params) {
    const { id } = params;
    return myAxios.get("/api/Project/DeleteSingleById?projectId=" + id);
  },
  // 关闭对接
  closeAchDocking(params) {
    const { id } = params;
    return myAxios.get("/api/project/closedockingback?projectId=" + id);
  },
  closeDemDocking(params) {
    const { id } = params;
    return myAxios.get("/api/project/closedockingbackreq?projectId=" + id);
  },
  // 获取工程详情
  getProjectInfo(params) {
    const { id } = params;
    return myAxios.get("/api/Project/GetProDockingProgress?projectId=" + id);
  },
  // 添加项目流程状态
  addAchStatus(params) {
    return myAxios.post("/api/Project/AddProDockingProgress", params);
  },
  addDemStatus(params) {
    return myAxios.post("/api/project/addprodockingprogressreq", params);
  },
  // 成功对接
  successAchDocking(params) {
    const { id } = params;
    return myAxios.get("/api/project/setprorelationstatus?projectId=" + id);
  },
  successDemDocking(params) {
    const { id } = params;
    return myAxios.get("/api/project/setprorelationstatusreq?projectId=" + id);
  }
};
